module.exports = __webpack_public_path__ + "img/logoTA_RU.4c02b08b.svg";